module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Thunder-circle-d1cbfee8cd2e80de3809fce232e09a07.svg";